import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const customerCampaignsSlice = createSlice({
    name: "customerCampaigns",
    initialState: {
        page: 0,
        pageCount: 0,
        success: false,
        fail: false,
        listData: null,
        detailData: null,
        statsData: null,
        checkpointsData: null,
        errorDetailData: null,
    },
    reducers: {
        doGetCustomerCampaignsListSuccess: (state, action) => {
            state.listData = action.payload.data;
            state.page = action.payload?.pagination?.page;
            state.pageCount = action.payload?.pagination?.totalPages;
        },
        doGetCustomerCampaignsListFail: (state, action) => {
            state.listData = null;
            state.page = 0;
            state.pageCount = 0;
            state.errorDetailData = action.payload;
        },
        doGetCustomerCampaignsDetailSuccess: (state, action) => {
            state.detailData = action.payload.data;
        },
        doGetCustomerCampaignsDetailFail: (state, action) => {
            state.detailData = null;
            state.errorDetailData = action.payload;
        },
        doGetCustomerCampaignsStatsSuccess: (state, action) => {
            state.statsData = action.payload.data;
        },
        doGetCustomerCampaignsStatsFail: (state, action) => {
            state.statsData = null;
            state.errorDetailData = action.payload;
        },
        doGetCustomerCampaignsCheckpointsSuccess: (state, action) => {
            state.checkpointsData = action.payload.data;
        },
        doGetCustomerCampaignsCheckpointsFail: (state, action) => {
            state.checkpointsData = null;
            state.errorDetailData = action.payload;
        },
        resetCustomerCampaignsStateSuccess: (state, action) => {
            state.success = action.payload;
            state.fail = action.payload;
            state.detailData = null;
            state.checkpointsData = null;
            state.errorDetailData = null;
        },
    },
});

/**
 * Get customer campaigns list with pagination and filters
 */
export const doGetCustomerCampaignsList = (param) => async (dispatch) => {
    try {
        let url = `/api/admin/customer-campaigns?page=${param.page}&size=${param.limit || 10}`;

        if (param.status) {
            url += `&status=${encodeURIComponent(param.status)}`;
        }
        if (param.customer_id) {
            url += `&customer_id=${param.customer_id}`;
        }
        if (param.start_date_from) {
            url += `&start_date_from=${encodeURIComponent(param.start_date_from)}`;
        }
        if (param.start_date_to) {
            url += `&start_date_to=${encodeURIComponent(param.start_date_to)}`;
        }

        const response = await axios.get(url);
        dispatch(doGetCustomerCampaignsListSuccess(response.data));
    } catch (error) {
        dispatch(doGetCustomerCampaignsListFail(error.response));
    }
};

/**
 * Get single customer campaign details
 */
export const doGetCustomerCampaignsDetail = (param) => async (dispatch) => {
    try {
        const url = `/api/admin/customer-campaigns/${param.id}`;
        const response = await axios.get(url);
        dispatch(doGetCustomerCampaignsDetailSuccess(response.data));
    } catch (error) {
        dispatch(doGetCustomerCampaignsDetailFail(error.response));
    }
};

/**
 * Get campaign statistics
 */
export const doGetCustomerCampaignsStats = () => async (dispatch) => {
    try {
        const url = `/api/admin/customer-campaigns/stats`;
        const response = await axios.get(url);
        dispatch(doGetCustomerCampaignsStatsSuccess(response.data));
    } catch (error) {
        dispatch(doGetCustomerCampaignsStatsFail(error.response));
    }
};

/**
 * Get checkpoints for a campaign
 */
export const doGetCustomerCampaignsCheckpoints = (param) => async (dispatch) => {
    try {
        const url = `/api/admin/customer-campaigns/${param.id}/checkpoints`;
        const response = await axios.get(url);
        dispatch(doGetCustomerCampaignsCheckpointsSuccess(response.data));
    } catch (error) {
        dispatch(doGetCustomerCampaignsCheckpointsFail(error.response));
    }
};

/**
 * Reset customer campaigns state
 */
export const resetCustomerCampaignsState = () => async (dispatch) => {
    dispatch(resetCustomerCampaignsStateSuccess(false));
};

// Export actions
export const {
    doGetCustomerCampaignsListSuccess,
    doGetCustomerCampaignsListFail,
    doGetCustomerCampaignsDetailSuccess,
    doGetCustomerCampaignsDetailFail,
    doGetCustomerCampaignsStatsSuccess,
    doGetCustomerCampaignsStatsFail,
    doGetCustomerCampaignsCheckpointsSuccess,
    doGetCustomerCampaignsCheckpointsFail,
    resetCustomerCampaignsStateSuccess,
} = customerCampaignsSlice.actions;

// Export selectors
export const getCustomerCampaignsList = (state) => state.customerCampaigns?.listData;
export const getCustomerCampaignsListPage = (state) => state.customerCampaigns?.page;
export const getCustomerCampaignsListPageCount = (state) => state.customerCampaigns?.pageCount;
export const getCustomerCampaignsDetail = (state) => state.customerCampaigns?.detailData;
export const getCustomerCampaignsStats = (state) => state.customerCampaigns?.statsData;
export const getCustomerCampaignsCheckpoints = (state) => state.customerCampaigns?.checkpointsData;
export const getCustomerCampaignsErrorDetailData = (state) => state.customerCampaigns?.errorDetailData;
export const getCustomerCampaignsSuccess = (state) => state.customerCampaigns?.success;
export const getCustomerCampaignsFail = (state) => state.customerCampaigns?.fail;

export default customerCampaignsSlice.reducer;
